import axios from 'axios'
import { axiosInterceptors } from '@ecom/customer-common-front'
import { env } from '@ecom/customer-common-front'

const axiosAem = axios.create({})

axiosInterceptors.urlInterceptor(axiosAem, env.generateGetter('apiAem'))

export default axiosAem
